module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-tabs sale-team"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n        当前文件数量：" + _vm._s(_vm.fileList.length) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "inline-item"
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.uploadUlr,
      "data": _vm.uploadData,
      "before-upload": _vm.beforeUpload,
      "on-success": _vm.handleUpload,
      "on-error": _vm.handleUploadError,
      "on-progress": _vm.handleProgress,
      "show-file-list": false
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.set_upload_param
    }
  }, [_vm._v("文件上传")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "item-list"
  }, [_vm._l((_vm.fileList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "item",
      attrs: {
        "index": index,
        "link": item
      }
    }, [(item.progress) ? [_c('div', {
      staticClass: "icon",
      class: _vm.fileIcoPath(item)
    }), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": item.filename,
        "placement": "top"
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.formatFilename(item.filename)))])]), _vm._v(" "), _c('div', {
      staticClass: "progress"
    }, [_c('span', {
      staticClass: "progress-bar"
    }, [_c('el-progress', {
      attrs: {
        "percentage": _vm.parsePercent(item.percent),
        "stroke-width": 2
      }
    })], 1), _vm._v(" "), (item.error) ? _c('span', {
      staticClass: "progress-tip"
    }, [_vm._v("上传失败")]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
      staticClass: "option"
    }, [(item.error) ? _c('a', {
      staticClass: "try-again",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.tryAgainUploading(item.uid)
        }
      }
    }, [_vm._v("重试")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "del",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.deleteUploading(item.uid)
        }
      }
    }, [_vm._v("删除")])])] : [_c('div', {
      staticClass: "icon",
      class: _vm.fileIcoPath(item)
    }), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": item.filename,
        "placement": "top"
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.formatFilename(item.filename)))])]), _vm._v(" "), (!item.id) ? _c('div', {
      staticClass: "author"
    }, [_vm._v(_vm._s(item.typeStr) + " 文件")]) : _c('div', {
      staticClass: "author"
    }, [_vm._v(_vm._s(item.uploadName) + " " + _vm._s(item.uploadTime) + " 上传")])], 1), _vm._v(" "), _c('div', {
      staticClass: "size"
    }, [_vm._v(_vm._s(_vm._f("formatUnit")(item.size)))]), _vm._v(" "), _c('div', {
      staticClass: "option"
    }, [(_vm.isShowFile(item)) ? _c('a', {
      staticClass: "view",
      attrs: {
        "href": _vm.clickPreview(item),
        "index": index,
        "target": "_blank"
      }
    }, [_vm._v("预览")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "download",
      attrs: {
        "href": _vm.getDownloadUrl(item.id, item.attachIndex),
        "download": item.filename
      }
    }, [_vm._v("下载")]), _vm._v(" "), (_vm.isSummit) ? _c('a', {
      staticClass: "del",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.handleDelete(item)
        }
      }
    }, [_vm._v("删除")]) : _vm._e()])]], 2)
  }), _vm._v(" "), (!_vm.fileList.length) ? _c('li', {
    staticClass: "item center"
  }, [_vm._v("暂无数据")]) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46bb391f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/file-cabinet/index.vue
// module id = 1258
// module chunks = 82